import { useRequest, useTitle } from 'ahooks'
import { Button, Form, PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { routes } from '@/router'

import { PortfolioForm } from './portfolio-form.component'

export const PortfolioCreateContainer = () => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const history = useHistory()

  useTitle(t('portfolio.create'), { restoreOnUnmount: true })

  const { loading, run } = useRequest(
    (data) => ({
      url: '/api/portfolio/createPortfolio',
      method: 'post',
      data,
    }),
    {
      manual: true,
      onSuccess: (data) => {
        history.push(routes.portfolio.page(data.selfId))
      },
    }
  )

  return (
    <>
      <PageHeader title={t('portfolio.create')} onBack={() => history.goBack()} />
      <div className='py-8px px-32px'>
        <PortfolioForm form={form} onSubmit={run}>
          <Button type='primary' htmlType='submit' loading={loading}>
            {t('portfolio.create')}
          </Button>
        </PortfolioForm>
      </div>
    </>
  )
}
